export const isNonEmptyObject = <T extends Record<string, unknown>>(obj: T): boolean =>
  obj !== null && obj !== undefined && typeof obj === "object" && Object.getOwnPropertyNames(obj).length > 0;
